import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Introduction from '@/components/Introduction'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
    },
    {
      path: '*',    // 此处需特别注意至于最底部
      component: () => import('@/components/Leader.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js